

(function ($) {
  "use strict";

  jQuery(document).ready(function(){


    /*--
    Menu Sticky
-----------------------------------*/
    var windows = $(window);
    var sticky = $('.header-sticky');
    var hh = windows.height(); /*not use rn - returns windows viewport height*/

    windows.on('scroll', function() {
      var scroll = windows.scrollTop();
      if (scroll < 100) {
        sticky.removeClass('is-sticky');
      }else{
        sticky.addClass('is-sticky');
      }
    });

    /*--
    Mobile Menu
------------------------*/
    var menuNav = $('nav.main-navigation');
    menuNav.meanmenu({
      meanScreenWidth: '991',
      meanMenuContainer: '.mobile-menu',
      meanMenuClose: '<span class="menu-close"></span>',
      meanMenuOpen: '<span class="menu-bar"></span>',
      meanRevealPosition: 'right',
      meanMenuCloseSize: '0',
    });

    /*--
   Sidebar Search Active
-----------------------------*/
    function sidebarSearch() {
      var searchTrigger = $('.trigger-search'),
          endTriggersearch = $('button.search-close'),
          container = $('.main-search-active'),
          inputFieldc = document.querySelector('.sidebar-search-input .form-search input'),
          containerClick = $('.clear-close-overlay'); /*--- Added ---*/

      searchTrigger.on('click', function() {
        if(inputFieldc){
          inputFieldc.focus();
        }
        container.addClass('inside');
      });

      endTriggersearch.on('click', function() {
        container.removeClass('inside');
      });
      
      /*--- Added ---*/
      containerClick.on('click', function() {
        container.removeClass('inside');
      });      

    };
    sidebarSearch();

/*----------------------------------------*/


    /*-- Brand Slider --*/
    var blogSlider = $('.blog-image-slider');
    blogSlider.slick({
      arrows: true,
      autoplay: false,
      dots: false,
      pauseOnFocus: true,
      pauseOnHover: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScoll: 1,
      prevArrow: '<button type="button" class="slick-prev"> <i class="icon-arrow-left"></i> </button>',
      nextArrow: '<button type="button" class="slick-next"><i class="icon-arrow-right"></i></button>',
    });

    /*--
    vertical-product-active
--------------------------------------*/
    $('.vartical-product-active').slick({
      slidesToShow: 4,
      autoplay: false,
      vertical:true,
      verticalSwiping:true,
      infinite:false,
      slidesToScroll: 3,
      nextArrow:'<i class="icon-arrow-down"></i>',
      prevArrow:'<i class="icon-arrow-up"></i>',
      button:false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          }
        },
        { breakpoint: 991,
         settings: {
           slidesToShow: 3,
           vertical:false,
         }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            vertical:false,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            vertical:false,
          }
        }
      ]

    });	     
    $('.vartical-product-active a').on('click', function () {
      $('.vartical-product-active a').removeClass('active');
    });

    /*--
    vertical-product-active
--------------------------------------*/
    $('.horizantal-product-active').slick({
      slidesToShow: 4,
      autoplay: false,
      vertical:false,
      verticalSwiping:true,
      slidesToScroll: 1,
      prevArrow:'<i class="icon-arrow-top arrow-prv"></i>',
      nextArrow:'<i class="icon-arrow-bottom arrow-next"></i>',
      button:false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          }
        },
        { breakpoint: 991,
         settings: {
           slidesToShow: 3,
         }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
          }
        }
      ]

    });	     
    $('.horizantal-product-active a').on('click', function () {
      $('.horizantal-product-active a').removeClass('active');
    });



    /*--
    Magnific Popup
------------------------*/
    $('.img-poppu').magnificPopup({
      type: 'image',
      gallery:{
        enabled:true
      }
    });
    

/*--
    Accordion
-------------------------*/
  $(".faequently-accordion").collapse({
      accordion:true,
    open: function() {
      this.slideDown(300);
    },
    close: function() {
      this.slideUp(300);
    }		
  });	

    /* --
    counterUp 
-----------------------------*/
    $('.count').counterUp({
      delay: 10,
      time: 1000
    });

    /*--
    ScrollUp Active
-----------------------------------*/
    $.scrollUp({
      scrollText: '<i class="ion-chevron-up"></i>',
      easingType: 'linear',
      scrollSpeed: 900,
      animation: 'fade'
    });   



    
  });
})(jQuery);	




/*** jc get url param | A function to turn all your URL parameters as neat objects ADDED ***/
console.log(window.location.search);

const colllection = urlParams.get('coll')
console.log(colllection);

function getAllUrlParams(url) {

  // get query string from url (optional) or window
  var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

  // we'll store the parameters here
  var obj = {};

  // if query string exists
  if (queryString) {

    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split('#')[0];

    // split our query string into its component parts
    var arr = queryString.split('&');

    for (var i = 0; i < arr.length; i++) {
      // separate the keys and the values
      var a = arr[i].split('=');

      // set parameter name and value (use 'true' if empty)
      var paramName = a[0];
      var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

      // (optional) keep case consistent
      paramName = paramName.toLowerCase();
      if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

      // if the paramName ends with square brackets, e.g. colors[] or colors[2]
      if (paramName.match(/\[(\d+)?\]$/)) {

        // create key if it doesn't exist
        var key = paramName.replace(/\[(\d+)?\]/, '');
        if (!obj[key]) obj[key] = [];

        // if it's an indexed array e.g. colors[2]
        if (paramName.match(/\[\d+\]$/)) {
          // get the index value and add the entry at the appropriate position
          var index = /\[(\d+)\]/.exec(paramName)[1];
          obj[key][index] = paramValue;
        } else {
          // otherwise add the value to the end of the array
          obj[key].push(paramValue);
        }
      } else {
        // we're dealing with a string
        if (!obj[paramName]) {
          // if it doesn't exist, create property
          obj[paramName] = paramValue;
        } else if (obj[paramName] && typeof obj[paramName] === 'string'){
          // if property does exist and it's a string, convert it to an array
          obj[paramName] = [obj[paramName]];
          obj[paramName].push(paramValue);
        } else {
          // otherwise add the property
          obj[paramName].push(paramValue);
        }
      }
    }
  }

  return obj;
}
/*
getAllUrlParams().product; // 'shirt'
getAllUrlParams().color; // 'blue'
getAllUrlParams().newuser; // true
getAllUrlParams().nonexistent; // undefined
getAllUrlParams('http://test.com/?a=abc').a; // 'abc'

LINK:   https://www.sitepoint.com/get-url-parameters-with-javascript/
*/

/*** jc-end get url param | A function to turn all your URL parameters as neat objects ***/